import React from 'react'
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Paper,
    Typography,
    Tooltip
} from '@mui/material/';
import SaveIcon from '@mui/icons-material/Save';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DiagramaStep from '../DiagramaStep';

const ModalDiagrama = (props) => {
    const {
        abrirModal,
        handleClose, 
        guardarNuevo, 
        setTitulo,
        titulo,
        setColeccionesDiagrama,
        coleccionesDiagrama
    } = props;
    

    return (
        <Dialog
            open={abrirModal}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
        >
            <DialogContent>
                <Typography
                    variant="h4"
                    align='center'
                    sx={{
                        marginBottom: '20px',
                        fontWeight: 'bold'
                    }}
                >
                    Guardar Diagrama
                </Typography>

                
                <DiagramaStep
                    guardarNuevo={guardarNuevo}
                    setTitulo={setTitulo}
                    titulo={titulo}
                    setColeccionesDiagrama={setColeccionesDiagrama}
                    coleccionesDiagrama={coleccionesDiagrama}
                />
            </DialogContent>

            <DialogActions>
                
            </DialogActions>
        </Dialog>
    )
}

export default ModalDiagrama